var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTumblr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 512 511.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.762 0H102.239C46.017 0 0 46.022 0 102.238v307.516c0 56.215 46.017 102.232 102.239 102.232h307.523C465.97 511.986 512 465.969 512 409.754V102.238C512 46.022 465.97 0 409.762 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M344.179 415.455h-53.948c-48.587 0-84.795-24.995-84.795-84.796v-95.756h-44.147v-51.85c48.587-12.618 68.903-54.427 71.246-90.63h50.452v82.22h58.855v60.26h-58.855v83.378c0 24.996 12.611 33.639 32.694 33.639h28.498v63.535z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/tumblr.0adbea98997e98ecc37a9727c93f5c59.svg";
export { ForwardRef as ReactComponent };